import {
  DEFAULT_VALUE,
  IListingData,
  IPostLoggingData,
  ISendLoggingEventProps,
  sendLoggingEvent,
} from "./sendLoggingEvent";
import {
  EnumActionNameLevel1,
  EnumActionNameLevel2,
  EnumActionNameLevel3,
  EnumCellType,
  EnumGeneratedBy,
  EnumLoggingScreenNames,
  EnumReferenceEntity,
  EnumUserTargetType,
  EnumUxTypes,
  EnumWidgets,
} from "../types/loggingTypes";
import {EnumJobsVertical, IPostData} from "models/post";
import { CookiesConstants, LocalStorageConstants } from "utils/constants";

import { parseCookies, setCookie } from "utils/nookies";
import { ICategoryLiteAsset } from "models/Assets/ICategoryAsset";
import {IJobPosterPostView, IJobSeekerPostView} from "models/jobPostView";
import {iPostListingData} from "../../../screens/PostView/_private/Api/types";

export function loadScreenAction({
  currentScreen,
  post,
  isShop,
  httpReferrer,
}: {
  currentScreen: EnumLoggingScreenNames;
  post?: IPostLoggingData;
  isShop?: boolean;
  httpReferrer?: string;
}) {
  const cookies = parseCookies();
  localStorage.setItem(
    LocalStorageConstants.CURRENT_LOGGING_SCREEN_NAME,
    currentScreen
  );
  sendLoggingEvent({
    actionNameLvl1: EnumActionNameLevel1.SCREEN,
    actionNameLvl2: EnumActionNameLevel2.LOAD,
    actionNameLvl3: EnumActionNameLevel3.SUCCESS,
    currentScreenName: currentScreen,
    post,
    ux_type: EnumUxTypes.SCREEN,
    generatedBy: EnumGeneratedBy.USER,
    userTargetType: isShop
      ? EnumUserTargetType.Membership
      : EnumUserTargetType.Free,
    httpReferrer: httpReferrer
      ? httpReferrer
      : document?.referrer || DEFAULT_VALUE,
  } as ISendLoggingEventProps).then(() => {
    let prev = cookies[CookiesConstants.PREVIOUS_LOGGING_SCREEN_NAME]
      ? cookies[CookiesConstants.PREVIOUS_LOGGING_SCREEN_NAME].split(",")
      : [EnumLoggingScreenNames.NA];
    // previous
    if (prev[prev.length - 1] != currentScreen) {
      prev = [prev[prev.length - 1], currentScreen];
      setCookie(
        null,
        CookiesConstants.PREVIOUS_LOGGING_SCREEN_NAME,
        prev.join(",")
      );
    }
  });
}
// listing

export function applyCvAction({ post }: { post?: IPostLoggingData }) {
  sendLoggingEvent({
    actionNameLvl1: EnumActionNameLevel1.APPLY,
    actionNameLvl2: EnumActionNameLevel2.LISTING,
    actionNameLvl3: EnumActionNameLevel3.CLICK,
    post,
    currentWidgetName: EnumWidgets.LISTING_LEADS,
    targetId: post?.member_id,
    ux_type: EnumUxTypes.BUTTON,
    generatedBy: EnumGeneratedBy.USER,
    referenceEntity: EnumReferenceEntity.POST,
    referenceId: post?.post_id,
  } as ISendLoggingEventProps);
}

export function addListingAction({
  post,
  widgetName,
}: {
  post?: IPostLoggingData;
  widgetName?: EnumWidgets;
}) {
  const currentScreen = getLastScreenName();
  sendLoggingEvent({
    actionNameLvl1: EnumActionNameLevel1.ADD,
    actionNameLvl2: EnumActionNameLevel2.LISTING,
    actionNameLvl3: EnumActionNameLevel3.CLICK,
    post,
    currentWidgetName: widgetName,
    ux_type: EnumUxTypes.BUTTON,
    generatedBy: EnumGeneratedBy.USER,
    sessionFunnel: localStorage.getItem(
      LocalStorageConstants.CURRENT_LOGGING_SCREEN_NAME
    ),
  } as ISendLoggingEventProps);
}

export function viewListingAction({
  post,
  widgetName,
  actionNameLvl3 = EnumActionNameLevel3.CLICK,
  ux_type = EnumUxTypes.LIST_CELL,
  previousScreen,
  listingData,
  referenceEntity,
  cellType,
  referenceId,
  httpReferrer,
}: {
  actionNameLvl3?: EnumActionNameLevel3;
  post?: IPostLoggingData | any;
  widgetName?: EnumWidgets;
  ux_type?: EnumUxTypes;
  currentScreen?: EnumLoggingScreenNames;
  previousScreen?: EnumLoggingScreenNames;
  listingData?: IListingData;
  referenceEntity?: EnumReferenceEntity;
  cellType?: EnumCellType;
  referenceId?: number | string;
  httpReferrer?: string;
}) {
  sendLoggingEvent({
    actionNameLvl1: EnumActionNameLevel1.VIEW,
    actionNameLvl2: EnumActionNameLevel2.LISTING,
    actionNameLvl3: actionNameLvl3,
    post,
    previousScreenName: previousScreen,
    currentWidgetName: widgetName,
    ux_type: ux_type,
    generatedBy: EnumGeneratedBy.USER,
    referenceEntity: referenceEntity || EnumReferenceEntity.POST,
    referenceId: referenceId || listingData?.postId || post?.post_id ? post?.post_id : post?.postId ? post?.postId : post?.listing?.listing_id ? post?.listing?.listing_id : post?.id ? post?.id : DEFAULT_VALUE,
    listingData: listingData,
    targetId: post?.member_id,
    cellType: cellType || DEFAULT_VALUE,
    httpReferrer: httpReferrer
      ? httpReferrer
      : document?.referrer || DEFAULT_VALUE,
  } as ISendLoggingEventProps);
}

//loan
export type LoanActions = "click" | "submit" | "success";
export const ON_LOAN_APPLY = "on-loan-apply";
export const AddLoanAction = (
  postData: IPostLoggingData,
  type: LoanActions
) => {
  const actionNameLvl3 =
    {
      click: EnumActionNameLevel3.CLICK,
      submit: EnumActionNameLevel3.SUBMIT,
      success: EnumActionNameLevel3.SUCCESS,
    }[type] || DEFAULT_VALUE;

  const loggingData = {
    post: postData,
    actionNameLvl1: EnumActionNameLevel1.ADD,
    actionNameLvl2: EnumActionNameLevel2.LOAN,
    actionNameLvl3,
    currentWidgetName: EnumWidgets.LISTING_LEADS,
    ux_type: EnumUxTypes.BUTTON,
    generatedBy: EnumGeneratedBy.USER,
    sessionFunnel: DEFAULT_VALUE,
    targetId: DEFAULT_VALUE,
    userTargetType: EnumUserTargetType.NA,
  };
  sendLoggingEvent(loggingData as ISendLoggingEventProps);
};

//member
export function viewMemberAction({
  widgetName,
  actionNameLvl3 = EnumActionNameLevel3.CLICK,
  ux_type = EnumUxTypes.BUTTON,
  currentScreen,
  referenceId,
  isShop,
  post,
}: {
  actionNameLvl3?: EnumActionNameLevel3;
  widgetName?: EnumWidgets;
  ux_type?: EnumUxTypes;
  currentScreen?: EnumLoggingScreenNames;
  referenceId?: string | number;
  isShop?: boolean;
  post?: IPostLoggingData;
}) {
  sendLoggingEvent({
    post,
    actionNameLvl1: EnumActionNameLevel1.VIEW,
    actionNameLvl2: EnumActionNameLevel2.MEMBER,
    actionNameLvl3: actionNameLvl3,
    currentWidgetName: widgetName,
    ux_type: ux_type,
    generatedBy: EnumGeneratedBy.USER,
    referenceEntity: EnumReferenceEntity.MEMBER,
    referenceId: referenceId,
    targetId: referenceId,
    userTargetType: isShop
      ? EnumUserTargetType.Membership
      : EnumUserTargetType.Free,
  } as ISendLoggingEventProps);
}

//order
export function orderStartAction({
  post,
  widgetName,
}: {
  actionNameLvl3?: EnumActionNameLevel3;
  post?: IPostLoggingData;
  widgetName?: EnumWidgets;
}) {
  sendLoggingEvent({
    actionNameLvl1: EnumActionNameLevel1.ORDER,
    actionNameLvl2: EnumActionNameLevel2.START,
    actionNameLvl3: EnumActionNameLevel3.CLICK,
    post,
    currentWidgetName: widgetName,
    ux_type: EnumUxTypes.BUTTON,
    generatedBy: EnumGeneratedBy.USER,
    targetId: post?.member_id,
    sessionFunnel: localStorage.getItem(
      LocalStorageConstants.CURRENT_LOGGING_SCREEN_NAME
    ),
  } as ISendLoggingEventProps);
}

//order
export function orderProductsViewAction({
  post,
  widgetName,
}: {
  actionNameLvl3?: EnumActionNameLevel3;
  post?: IPostLoggingData;
  widgetName?: EnumWidgets;
}) {
  sendLoggingEvent({
    actionNameLvl1: EnumActionNameLevel1.ORDER,
    actionNameLvl2: EnumActionNameLevel2.PRODUCTS,
    actionNameLvl3: EnumActionNameLevel3.VIEW,
    post,
    currentWidgetName: widgetName,
    ux_type: EnumUxTypes.BUTTON,
    generatedBy: EnumGeneratedBy.USER,
    targetId: post?.member_id,
  } as ISendLoggingEventProps);
}
//favourite
export function favoriteLoggingAction({
  post,
  widgetName,
  actionNameLvl2 = EnumActionNameLevel2.LISTING_ADD,
  actionNameLvl3 = EnumActionNameLevel3.CLICK,
  ux_type = EnumUxTypes.BUTTON,
  cellType,
}: {
  actionNameLvl3?: EnumActionNameLevel3;
  actionNameLvl2?: EnumActionNameLevel2;
  post?: IPostLoggingData | any;
  widgetName?: EnumWidgets;
  ux_type?: EnumUxTypes;
  cellType?: EnumCellType;
}) {
  sendLoggingEvent({
    actionNameLvl1: EnumActionNameLevel1.FAVORITE,
    actionNameLvl2: actionNameLvl2,
    actionNameLvl3: actionNameLvl3,
    post,
    currentWidgetName: widgetName,
    ux_type: ux_type,
    generatedBy: EnumGeneratedBy.USER,
    referenceEntity: EnumReferenceEntity.POST,
    referenceId: post?.post_id ? post?.post_id : post?.postId ? post?.postId : post?.listing?.listing_id ? post?.listing?.listing_id : post?.id ? post?.id : DEFAULT_VALUE,
    cellType: cellType,
  } as ISendLoggingEventProps);
}

// follow
export function followAddClickAction({
  post,
  ux_type = EnumUxTypes.BUTTON,
  currentScreen,
  referenceId,
  userTargetType,
}: {
  post?: IPostLoggingData;
  ux_type?: EnumUxTypes;
  currentScreen?: EnumLoggingScreenNames;
  referenceId?: string;
  userTargetType?: string;
}) {
  sendLoggingEvent({
    actionNameLvl1: EnumActionNameLevel1.FOLLOW,
    actionNameLvl2: EnumActionNameLevel2.ADD,
    actionNameLvl3: EnumActionNameLevel3.CLICK,
    post,
    currentWidgetName: EnumWidgets.LISTER_OVERVIEW,
    ux_type: ux_type,
    targetId: referenceId ? referenceId : post?.member_id || DEFAULT_VALUE,
    referenceEntity: EnumReferenceEntity.MEMBER,
    referenceId: referenceId,
    userTargetType: userTargetType,
  } as ISendLoggingEventProps);
}

export function followAddSuccessAction({
  post,
  ux_type = EnumUxTypes.BUTTON,
  currentScreen,
  referenceId,
  userTargetType,
}: {
  post?: IPostLoggingData;
  ux_type?: EnumUxTypes;
  currentScreen?: EnumLoggingScreenNames;
  referenceId?: string;
  userTargetType?: string;
}) {
  sendLoggingEvent({
    actionNameLvl1: EnumActionNameLevel1.FOLLOW,
    actionNameLvl2: EnumActionNameLevel2.ADD,
    actionNameLvl3: EnumActionNameLevel3.SUCCESS,
    post,
    currentWidgetName: EnumWidgets.LISTER_OVERVIEW,
    ux_type: ux_type,
    targetId: referenceId || DEFAULT_VALUE,
    referenceEntity: EnumReferenceEntity.MEMBER,
    referenceId: referenceId,
    userTargetType: userTargetType,
  } as ISendLoggingEventProps);
}

export function followRemoveClickAction({
  post,
  ux_type = EnumUxTypes.BUTTON,
  currentScreen,
  referenceId,
  userTargetType,
}: {
  post?: IPostLoggingData;
  ux_type?: EnumUxTypes;
  currentScreen?: EnumLoggingScreenNames;
  referenceId?: string;
  userTargetType?: string;
}) {
  sendLoggingEvent({
    actionNameLvl1: EnumActionNameLevel1.FOLLOW,
    actionNameLvl2: EnumActionNameLevel2.REMOVE,
    actionNameLvl3: EnumActionNameLevel3.CLICK,
    post,
    currentWidgetName: EnumWidgets.LISTER_OVERVIEW,
    ux_type: ux_type,
    targetId: referenceId || DEFAULT_VALUE,
    referenceEntity: EnumReferenceEntity.MEMBER,
    referenceId: referenceId,
    userTargetType: userTargetType,
  } as ISendLoggingEventProps);
}

export function followRemoveSuccessAction({
  post,
  ux_type = EnumUxTypes.BUTTON,
  currentScreen,
  referenceId,
  userTargetType,
}: {
  post?: IPostLoggingData;
  ux_type?: EnumUxTypes;
  currentScreen?: EnumLoggingScreenNames;
  referenceId?: string;
  userTargetType?: string;
}) {
  sendLoggingEvent({
    actionNameLvl1: EnumActionNameLevel1.FOLLOW,
    actionNameLvl2: EnumActionNameLevel2.REMOVE,
    actionNameLvl3: EnumActionNameLevel3.SUCCESS,
    post,
    currentWidgetName: EnumWidgets.LISTER_OVERVIEW,
    ux_type: ux_type,
    targetId: referenceId || DEFAULT_VALUE,
    referenceEntity: EnumReferenceEntity.MEMBER,
    referenceId: referenceId,
    userTargetType: userTargetType,
  } as ISendLoggingEventProps);
}

export const getLastScreenName = (currentScreenName = null) => {
  const cookies = parseCookies();
  const prev = cookies[CookiesConstants.PREVIOUS_LOGGING_SCREEN_NAME]
    ? cookies[CookiesConstants.PREVIOUS_LOGGING_SCREEN_NAME].split(",")
    : [EnumLoggingScreenNames.NA];
  if (!currentScreenName) {
    return prev[prev.length - 1];
  }
  let prev_screen_name = EnumLoggingScreenNames.NA as string;
  if (prev[prev.length - 1] != currentScreenName) {
    prev_screen_name = prev[prev.length - 1];
  } else if (prev[prev.length - 2]) {
    prev_screen_name = prev[prev.length - 2];
  }
  return prev_screen_name;
};
//searches_save

// notification permission

export function permissionNotificationAction({
  actionNameLvl3,
}: {
  actionNameLvl3: EnumActionNameLevel3;
}) {
  sendLoggingEvent({
    actionNameLvl1: EnumActionNameLevel1.PERMISSION,
    actionNameLvl2: EnumActionNameLevel2.NOTIFICATION,
    actionNameLvl3: actionNameLvl3,
    currentScreenName: getLastScreenName(),
  } as ISendLoggingEventProps);
}

export function permissionLocationAction({
  actionNameLvl3,
}: {
  actionNameLvl3: EnumActionNameLevel3;
}) {
  sendLoggingEvent({
    actionNameLvl1: EnumActionNameLevel1.PERMISSION,
    actionNameLvl2: EnumActionNameLevel2.LOCATION,
    actionNameLvl3: actionNameLvl3,
  } as ISendLoggingEventProps);
}

const handleCellType = (post) => {
  switch (post?.sub_category_reporting_name || post?.view_type) {
    case "JobSeeker":
    case "jobSeeker":
    case "job-seekers":
      return EnumCellType.CV_CARD;
    case "JobPoster":
    case "jobPoster":
    case "job-vacancies":
      return EnumCellType.JOB_OPENING_CARD;
    default:
      return EnumCellType.CLASSIC;
  }
};

function handleReferenceEntity({
  post,
  subCategory,
}: {
  post: IPostData | IJobSeekerPostView | IJobPosterPostView | iPostListingData | IPostLoggingData
  subCategory?: ICategoryLiteAsset;
}) {
  if (post || subCategory) {
    switch ((post as IPostData)?.subcategory_reporting_name || (post as IPostData)?.view_type || (post as IJobSeekerPostView)?.sub_category_reporting_name || (post as IJobPosterPostView)?.sub_category_reporting_name || (post as iPostListingData)?.listing?.sub_category.reporting_name || subCategory?.reporting_name || (post as IPostLoggingData)?.sub_category_reporting_name) {
      case EnumJobsVertical.JOB_SEEKR:
        return EnumReferenceEntity.MEMBER;
      default:
        return EnumReferenceEntity.POST;
    }
  }
  return EnumReferenceEntity.MEMBER;
}

export function messageBuyerSend({
  post,
  userTargetType,
  member_id,
  uxType,
  subCategory,
  widgetName,
  referenceEntity,
}: {
  post?: IPostData | IJobSeekerPostView | IJobPosterPostView | iPostListingData | IPostLoggingData | any;
  userTargetType?: EnumUserTargetType;
  member_id?: string | number;
  uxType?: EnumUxTypes;
  subCategory?: ICategoryLiteAsset;
  widgetName?: EnumWidgets;
  referenceEntity?: EnumReferenceEntity;
}) {
  const isSearchPage = () => {
    return getLastScreenName() === EnumLoggingScreenNames.SEARCH;
  };
  sendLoggingEvent({
    post,
    actionNameLvl1: EnumActionNameLevel1.MESSAGE,
    actionNameLvl2: EnumActionNameLevel2.BUYER,
    actionNameLvl3: EnumActionNameLevel3.SEND,
    generatedBy: EnumGeneratedBy.USER_SHORTCUT,
    userTargetType: userTargetType,
    targetId: member_id
      ? member_id
      : (post as IPostLoggingData)?.member_id ? (post as IPostLoggingData)?.member_id : (post as IPostData)?.member_id ? (post as IPostData)?.member_id : (post as IJobPosterPostView)?.card?.member_id ? (post as IJobPosterPostView)?.card?.member_id : (post as IJobSeekerPostView)?.card?.member_id ? (post as IJobSeekerPostView)?.card?.member_id : (post as iPostListingData)?.listing?.member_id ? (post as iPostListingData)?.listing?.member_id
      : DEFAULT_VALUE,
    cellType: post && isSearchPage() ? handleCellType(post) : EnumCellType.NA,
    referenceEntity: referenceEntity
      ? referenceEntity
      : handleReferenceEntity({ post, subCategory }),
    referenceId: post?.postId ? post?.postId : post?.post_id ? post?.post_id : post?.listing?.listing_id ? post?.listing?.listing_id
        : (post as IPostLoggingData)?.member_id ? (post as IPostLoggingData)?.member_id : (post as IPostData)?.member_id ? (post as IPostData)?.member_id : (post as IJobPosterPostView)?.card?.member_id ? (post as IJobPosterPostView)?.card?.member_id : (post as IJobSeekerPostView)?.card?.member_id ? (post as IJobSeekerPostView)?.card?.member_id : (post as iPostListingData)?.listing?.member_id ? (post as iPostListingData)?.listing?.member_id
            : member_id
                ? member_id : DEFAULT_VALUE,
    ux_type: uxType ? uxType : EnumUxTypes.BUTTON,
    currentWidgetName: widgetName
      ? widgetName
      : post
      ? isSearchPage()
        ? EnumWidgets.LISTING_CELL
        : EnumWidgets.LISTING_LEADS
      : EnumWidgets.LISTER_OVERVIEW,
  } as ISendLoggingEventProps);
}

export function viewListingImage({
  post,
  member_id,
}: {
  post?: IPostLoggingData | any;
  member_id?: string | number;
}) {
  sendLoggingEvent({
    post,
    actionNameLvl1: EnumActionNameLevel1.VIEW,
    actionNameLvl2: EnumActionNameLevel2.LISTING,
    actionNameLvl3: EnumActionNameLevel3.IMAGE,
    generatedBy: EnumGeneratedBy.USER,
    userTargetType: post?.member_isShop ? EnumUserTargetType?.Membership : EnumUserTargetType.Free,
    targetId: post?.member_id,
    referenceEntity: EnumReferenceEntity?.POST,
    referenceId: post?.post_id ? post?.post_id : post?.postId ? post?.postId : post?.listing?.listing_id ? post?.listing?.listing_id : post?.id ? post?.id : DEFAULT_VALUE,
    ux_type: EnumUxTypes.IMAGE,
    currentWidgetName: EnumWidgets.LISTING_IMAGE,
  } as ISendLoggingEventProps);
}

export function viewListingVideo({
  post,
  member_id,
}: {
  post?: IPostLoggingData | any;
  member_id?: string | number;
}) {
  sendLoggingEvent({
    post,
    actionNameLvl1: EnumActionNameLevel1.VIEW,
    actionNameLvl2: EnumActionNameLevel2.LISTING,
    actionNameLvl3: EnumActionNameLevel3.VIDEO,
    generatedBy: EnumGeneratedBy.USER,
    userTargetType: post?.member_isShop
      ? EnumUserTargetType?.Membership
      : EnumUserTargetType.Free,
    targetId: post?.member_id,
    referenceEntity: EnumReferenceEntity?.POST,
    referenceId: post?.post_id ? post?.post_id : post?.postId ? post?.postId : post?.listing?.listing_id ? post?.listing?.listing_id : post?.id ? post?.id : DEFAULT_VALUE,
    ux_type: EnumUxTypes.IMAGE,
    currentWidgetName: EnumWidgets.LISTING_IMAGE,
  } as ISendLoggingEventProps);
}

export function messageCLickAction({
  post,
  member_id,
}: {
  post?: IPostLoggingData | any;
  member_id?: string | number;
}) {
  sendLoggingEvent({
    post,
    actionNameLvl1: EnumActionNameLevel1.MESSAGE,
    actionNameLvl2: post?.member_id
        ? EnumActionNameLevel2.SELLER
        : EnumActionNameLevel2?.BUYER,
    actionNameLvl3: EnumActionNameLevel3.CLICK,
    generatedBy: EnumGeneratedBy.USER,
    userTargetType: post?.member_isShop
      ? EnumUserTargetType?.Membership
      : EnumUserTargetType.Free,
    targetId: post?.member_id,
    referenceEntity: EnumReferenceEntity?.POST,
    referenceId: post?.post_id ? post?.post_id : post?.postId ? post?.postId : post?.listing?.listing_id ? post?.listing?.listing_id : post?.id ? post?.id : DEFAULT_VALUE,
    ux_type: EnumUxTypes.IMAGE,
    currentWidgetName: EnumWidgets.LISTING_IMAGE,
  } as ISendLoggingEventProps);
}
export function messageMethodAction({
  post,
  member_id,
  actionLvl3,
}: {
  post?: IPostLoggingData | any;
  member_id?: string | number;
  actionLvl3?: EnumActionNameLevel3;
}) {
  sendLoggingEvent({
    post,
    actionNameLvl1: EnumActionNameLevel1.MESSAGE,
    actionNameLvl2: ((post as IPostLoggingData)?.member_id ? (post as IPostLoggingData)?.member_id : (post as IPostData)?.member_id ? (post as IPostData)?.member_id : (post as IJobPosterPostView)?.card?.member_id ? (post as IJobPosterPostView)?.card?.member_id : (post as IJobSeekerPostView)?.card?.member_id ? (post as IJobSeekerPostView)?.card?.member_id : (post as iPostListingData)?.listing?.member_id ? (post as iPostListingData)?.listing?.member_id
            : DEFAULT_VALUE) === member_id ? EnumActionNameLevel2.SELLER : EnumActionNameLevel2?.BUYER,
    actionNameLvl3: actionLvl3,
    generatedBy: EnumGeneratedBy.USER,
    userTargetType: post?.member_isShop
      ? EnumUserTargetType?.Membership
      : EnumUserTargetType.Free,
    targetId: post?.member_id,
    referenceEntity: EnumReferenceEntity?.POST,
    referenceId: post?.post_id ? post?.post_id : post?.postId ? post?.postId : post?.listing?.listing_id ? post?.listing?.listing_id : post?.id ? post?.id : DEFAULT_VALUE,
    ux_type: EnumUxTypes.IMAGE,
    currentWidgetName: EnumWidgets.LISTING_IMAGE,
  } as ISendLoggingEventProps);
}

export function upgradeAccountClick({
  currentWidgetName,
  member_id,
}: {
  currentWidgetName: EnumWidgets;
  member_id: string | number;
}) {
  sendLoggingEvent({
    actionNameLvl1: EnumActionNameLevel1.UPGRADE,
    actionNameLvl2: EnumActionNameLevel2.ACCOUNT,
    actionNameLvl3: EnumActionNameLevel3.CLICK,
    generatedBy: EnumGeneratedBy.USER,
    ux_type: EnumUxTypes.BUTTON,
    currentWidgetName: currentWidgetName,
    referenceEntity: EnumReferenceEntity.MEMBER,
    referenceId: member_id,
  } as ISendLoggingEventProps);
}
